import React from 'react';

import { FILE_BASE_URL } from 'variables';
import { WebImageProps } from 'types/webImageProps';

import { PageDescription } from 'components/page/PageDescription';
import { PageTitle } from 'components/page/PageTitle';
import { FlexContainer } from 'components/common/FlexContainer';
import { ReadMoreButton } from 'components/common/ReadMoreButton';
import { ReadMoreWrapper } from 'components/common/ReadMoreWrapper';
import { TransparentContainer } from 'components/common/TransparentContainer';
import { Wrapper } from './atoms/Wrapper';
import { Image } from './atoms/Image';
import { SectionWrapper } from './atoms/SectionWrapper';

interface Props {
    title: string;
    description: string;
    image: WebImageProps;
    readMore: {
        slug: string;
    };
}
export const ImageSectionIntro: React.FC<Props> = ({ title, description, image, readMore }) => {
    return (
        <Wrapper>
            <Image src={FILE_BASE_URL + image.webPPath} fallback={FILE_BASE_URL + image.imagePath} />
            <FlexContainer>
                <TransparentContainer>
                    <div>
                        <SectionWrapper>
                            <div>
                                <PageTitle>{title}</PageTitle>
                                <PageDescription>{description}</PageDescription>
                                <ReadMoreWrapper>
                                    <ReadMoreButton
                                        readMoreUrl={`/wat-bieden-wij-jou/${readMore.slug}`}
                                        type="wat-bieden-wij-jou"
                                    />
                                </ReadMoreWrapper>
                            </div>
                        </SectionWrapper>
                    </div>
                </TransparentContainer>
            </FlexContainer>
        </Wrapper>
    );
};
